import { render } from "./OrgNav.vue?vue&type=template&id=4da9f18c&ts=true"
import script from "./OrgNav.vue?vue&type=script&lang=ts"
export * from "./OrgNav.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__